import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {isEmpty} from 'lodash/lang';
import {CommonModal} from 'components/common';
import SchoolAssignedSubscriptionTable from './SchoolAssignedSubscriptionTable';
import SchoolAssignedSubscriptionForm from './SchoolAssignedSubscriptionForm';
import {
  fetchClassroomSubscriptions,
  setCurrentClassroomSubscriptionPage,
  clearClassroomSubscriptionsAfterPage,
} from 'actions/subscriptions';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import {setClassroomAvailableSubscription} from 'api/subscriptions';
import {parseIfIsNumber} from 'utils/common';
import FormErrors from '../common/FormErrors';

class SchoolAssignedSubscriptionList extends React.Component {
  static propTypes = {
    schoolId: PropTypes.number,
    fetchSchool: PropTypes.func.isRequired,
    classroomSubscriptionPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      refreshTableKey: 0,
      classroomSubscriptionData: null,
      errors: {},
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  showModal(classroomSubscriptionData) {
    this.setState({
      modalShown: true,
      classroomSubscriptionData,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
      classroomSubscriptionData: null,
    });
  }

  handleFormSubmit({availableSubscriptions}) {
    const {
      classroomSubscriptionData: {id: classroomId},
    } = this.state;
    const {fetchSchool, formatErrors} = this.props;
    setClassroomAvailableSubscription({
      classroomId,
      availableSubscriptions: parseInt(availableSubscriptions),
    })
      .then(() => {
        fetchSchool();
        this.setState((prevState) => ({
          modalShown: false,
          classroomSubscriptionData: false,
          refreshTableKey: prevState.refreshTableKey + 1,
        }));
      })
      .catch((err) =>
        formatErrors(err).then((errors) => {
          this.setState({
            errors,
          });
        }),
      );
  }

  render() {
    const {modalShown, classroomSubscriptionData, refreshTableKey, errors} = this.state;
    const {
      schoolId,
      classroomSubscriptionPages,
      fetchClassroomSubscriptions,
      setCurrentClassroomSubscriptionPage,
      clearClassroomSubscriptionsAfterPage,
    } = this.props;
    return (
      <div className="container content-box">
        <CommonModal title="Set Classroom Available Subscriptions" onClose={this.closeModal} show={modalShown}>
          <FormErrors errors={errors} />
          {!isEmpty(classroomSubscriptionData) && (
            <SchoolAssignedSubscriptionForm
              schoolId={schoolId}
              classroomSubscriptionData={classroomSubscriptionData}
              onSubmit={this.handleFormSubmit}
            />
          )}
        </CommonModal>
        <Panel>
          <h3 className="section-header">
            <div className="section-title">Classroom Subscriptions</div>
          </h3>
          <SchoolAssignedSubscriptionTable
            {...{
              refreshTableKey: refreshTableKey,
              recordPages: classroomSubscriptionPages,
              fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                fetchClassroomSubscriptions(q, page, perPage, sortOpts, {...extraFilters, schoolId}),
              setCurrentRecordPage: setCurrentClassroomSubscriptionPage,
              clearRecordsAfterPage: clearClassroomSubscriptionsAfterPage,
              showUpdateModal: this.showModal,
            }}
          />
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  schoolId: parseIfIsNumber(ownProps.schoolId),
  classroomSubscriptionPages: state.subscriptions.get('classroomSubscriptionPages').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  fetchClassroomSubscriptions: (...args) => dispatch(fetchClassroomSubscriptions(...args)),
  setCurrentClassroomSubscriptionPage: (...args) => dispatch(setCurrentClassroomSubscriptionPage(...args)),
  clearClassroomSubscriptionsAfterPage: (...args) => dispatch(clearClassroomSubscriptionsAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SchoolAssignedSubscriptionList);
